// extracted by mini-css-extract-plugin
export var attachment = "_kw-a";
export var emailContainer = "_kw-4";
export var emailContentPaddedContainer = "_kw-b";
export var emailHeader = "_kw-6";
export var emailIframe = "_kw-3";
export var emailInfoIcon = "_kw-9";
export var emailShortenedSummary = "_kw-e";
export var infoDropdown = "_kw-0";
export var infoRowBoundedContent = "_kw-d";
export var internal = "_kw-5";
export var merchant = "_kw-8";
export var messageInputContainer = "_kw-h";
export var normal = "_kw-7";
export var replyCard = "_kw-f";
export var subtleButton = "_kw-1";
export var subtleButtonIconContainer = "_kw-2";
export var toggleViewRepliesButton = "_kw-c";
export var wrappingText = "_kw-g";